'use strict';

var _ = require('lodash');

function SelectService ($document, $rootScope) {

  var ctrls = {};

  this.clicked = function (groupId, scope) {
    closeOthersInGroup(groupId, scope);
  };

  /**
   * Registers a select dropdown
   *
   * @param  {string} [groupId] group that this dropdown should be grouped with
   * @param  {object} ctrl Angular ctrl for the dropdown
   */
  this.register = function (groupId, ctrl) {
     if (ctrls[groupId]) {
      ctrls[groupId][ctrl.$id] = ctrl;
     }
     else {
       ctrls[groupId] = {};
       ctrls[groupId][ctrl.$id] = ctrl;
     }
  };

  this.unregister = function (groupId, scope) {
    if (ctrls[groupId]) {
      delete ctrls[groupId][scope.$id];
    }
    else {
      _.forEach(ctrls, function (group) {
        _.forEach(group, function (ctrl) {
          if (ctrl.$id === scope.$id) {
            delete ctrls[group][ctrl.$id];
          }
        });
      });
    }
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Helpers
  /////////////////////////////////////////////////////////////////////////////////////////////////


  var closeOthersInGroup = function (groupId, scope) {
    var group = ctrls[groupId];
    if (group) {
      _.forEach(group, function (ctrl) {
        if (ctrl.$id !== scope.$id) {
          ctrl.onBodyClick();
        }
      });
    }
  };


  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Testing Only
  //
  // The following have been exposed for testing only and not intended to be used
  /////////////////////////////////////////////////////////////////////////////////////////////////

  this._ctrls = ctrls;
}

module.exports = SelectService;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/form/src/select/SelectService.js